module.exports = __webpack_public_path__ + "static/media/14UNEP13.6f1ebc2c.jpg";